import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";
import type { Contributions, MemberProfileView } from "../members.types";

export function useMemberProfile(memberId: string | undefined) {
  return useQuery<MemberProfileView>({
    queryKey: ["afell", "member", memberId],
    queryFn: () => apiRequest(`/afell/directory/${memberId}/`),
    enabled: Boolean(memberId),
  });
}

export function useContributions(memberId: string | undefined) {
  return useQuery<Contributions>({
    queryKey: ["afell", "member", memberId, "contributions"],
    queryFn: () => apiRequest(`/afell/directory/${memberId}/contributions/`),
    enabled: Boolean(memberId),
  });
}
